import { connect } from 'react-redux';
import CardsAutocomplete from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(CardsAutocomplete);
